import {Component, OnInit} from '@angular/core';
import {ApiService} from "../../api.service";
import {HttpClient} from "@angular/common/http";
import {NameFormatter} from "../../util/name-formatter";
import {PlaceSearchComponent} from "../place-search/place-search.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss']
})
export class LocationSearchComponent extends PlaceSearchComponent implements OnInit {
  locations = [];

  constructor(protected apiService: ApiService,
              protected httpClient: HttpClient,
              protected nameFormatter: NameFormatter,
              protected router: Router) {
    super(apiService, httpClient);
  }

  ngOnInit() {
    this.apiService.get('locations').subscribe((locations: Location[]) => {
      locations.forEach((location: any) => {
        location.geo = `${location.address},${location.place}`;
        location.name = `${location.address} - ${location.place}, ${this.nameFormatter.format(location.name)}`;
      });
      this.locations = locations.sort(this.sortFunc);
    })
  }

  onChange() {
    if(this.selectedValue != null) {
      this.router.navigate([`meld-storing/${this.selectedValue.id}`]);
    }
    super.onChange();
  }
}
